// extracted by mini-css-extract-plugin
module.exports = {"rentalInfoWrapper":"Ao","status":"Ap","timeLeft":"Aq"};